var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHidden(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27.5,
    cy: 27.5,
    r: 27.5,
    fill: "#808080"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.4556 31.58H25.5856V31.04C25.5856 29.18 26.2756 27.71 28.5556 25.7C29.9656 24.41 30.2956 23.42 30.2956 22.31C30.2956 21.05 29.5756 19.88 27.8356 19.88C25.9756 19.88 25.2256 21.14 25.0156 22.79H21.3556C21.4756 20.51 22.9456 16.94 27.8956 16.97C32.6356 17 34.0756 20.12 34.0756 22.43C34.0756 24.38 33.4456 25.7 31.2856 27.71C29.9056 28.97 29.4556 29.96 29.4556 31.28V31.58ZM29.4556 38H25.5856V33.32H29.4556V38Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHidden);
export default __webpack_public_path__ + "static/media/hidden.007877c4c019359f779bff7bf427c57a.svg";
export { ForwardRef as ReactComponent };